import { render, staticRenderFns } from "./CompanyModelContainer.vue?vue&type=template&id=51fb6d30&"
import script from "./CompanyModelContainer.vue?vue&type=script&lang=ts&"
export * from "./CompanyModelContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports